import { Modal, Typography } from "antd";
const EnableNotification = ({ isOpen, onOk, onCancel }) => {
  return (
    <>
      <Modal
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={onOk}
        footer={
          <div className="flex justify-center">
            <button
              className="px-4 py-2 bg-[#176b53] text-[#fff] rounded"
              onClick={onOk}
            >
              Click here to enable
            </button>
          </div>
        }
        width={350}
      >
        <div className="flex flex-col justify-center items-center">
          <img width={60} src="QC_Logo.svg" alt="" />
          <Typography className="text-sm my-3">
            Please enable sound for new order notification.
          </Typography>
        </div>
      </Modal>
    </>
  );
};
export default EnableNotification;
